import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function Modal({ open, onClose, title, children, maxWidth = 'max-w-lg' }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4" onClick={onClose}>
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      {/* Content */}
      <div className={`relative flex max-h-[calc(100dvh-1rem)] min-w-0 w-full ${maxWidth} flex-col overflow-hidden rounded-xl border border-white/15 bg-[#131822] shadow-2xl shadow-black/50 sm:max-h-[85vh] sm:rounded-2xl`} onClick={e => e.stopPropagation()}>
        {/* Header */}
        {title && (
          <div className="flex flex-shrink-0 items-center justify-between gap-3 border-b border-white/10 bg-[#131822] px-4 py-3 sm:px-6 sm:py-4">
            <h3 className="min-w-0 break-words text-base font-semibold text-white sm:text-lg">{title}</h3>
            <button onClick={onClose} className="grid h-11 w-11 shrink-0 place-items-center rounded-lg text-gray-400 transition hover:bg-white/10 hover:text-white" aria-label="Close dialog">
              <X className="w-5 h-5" />
            </button>
          </div>
        )}
        {/* Body */}
        <div className="min-w-0 flex-1 overflow-x-auto overflow-y-auto overscroll-contain px-4 py-4 sm:px-6 sm:py-5 [&_img]:max-w-full [&_pre]:max-w-full [&_pre]:overflow-x-auto">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
